import { useTranslation } from "react-i18next";
import sponsor1 from "../../assets/images/sponsors/ES_FundedbytheEU.png";
import sponsor2 from "../../assets/images/sponsors/MEFPD.Gob.Web.png";
import sponsor3 from "../../assets/images/sponsors/logo-plan-rtr.png";
import sponsor4 from "../../assets/images/sponsors/logo-csd.png";
import sponsor5 from "../../assets/images/sponsors/logo-madrid.png";
import { Col, Container, Row } from "react-bootstrap";
import logo from '../../assets/images/logo-white-simple.svg';
import { Link } from "react-router-dom";
import { MainMenuItems } from "./main-menu-items";
import moment from "moment";

export default function Footer() {
    const { t } = useTranslation();

    const handleClose = () => {}

    return (
        <footer>
            <div className="footer-1">
                <Container>
                    <Row>
                        <Col>
                            <div className="sponsors">
                                <div className="sponsor-item sponsor1">
                                    <Link className="sponsor" to="/" title={ 'Financiado por la Unión Europea' }>
                                        <img alt={ 'Financiado por la Unión Europea' } src={sponsor1}/>
                                    </Link>
                                </div>
                                <div className="sponsor-item sponsor2">
                                    <Link className="sponsor" to="/" title={ 'Ministerio de Educación, Formación Profesional y Deportes' }>
                                        <img alt={ 'Ministerio de Educación, Formación Profesional y Deportes' } src={sponsor2}/>
                                    </Link>
                                </div>
                                <div className="sponsor-item sponsor3">
                                    <Link className="sponsor" to="/" title={ 'Plan de Recuperación, Transformación y Resilencia' }>
                                        <img alt={ 'Plan de Recuperación, Transformación y Resilencia' } src= {sponsor3}/>
                                    </Link>
                                </div>
                                <div className="sponsor-item sponsor4">
                                    <Link className="sponsor" to="/" title={ 'Consejo Superior de Deportes' }>
                                        <img alt={ 'Consejo Superior de Deportes' } src= {sponsor4}/>
                                    </Link>
                                </div>
                                <div className="sponsor-item sponsor5">
                                    <Link className="sponsor" to="/" title={ 'Comunidad de Madrid' }>
                                        <img alt={ 'Comunidad de Madrid' } src= {sponsor5}/>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="financing-info">
                                { '«Financiado por la Unión Europea - NextGenerationEU». Sin embargo, los puntos de vista y las opiniones expresadas son únicamente los del autor o autores y no reflejan necesariamente los de la Unión Europea o la Comisión Europea. Ni la Unión Europea ni la Comisión Europea pueden ser consideradas responsables de las mismas.' }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="footer-2">
                <Container>
                    <Row>
                        <Col>
                            <div className="branding">
                                <Link className="logo" to="/" title={ t("go_home")}>
                                    <img alt="Madrid Badminton" src= {logo}/>
                                </Link>
                            </div>
                            <MainMenuItems close={ handleClose } />
                            <div className="copyright">
                                &copy;{ moment().year() } { 'Madrid Badminton. All rights reserved.'}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </footer>
    );
}